class User {

    constructor() {
      this._email = null;
      this._aiwp_logged_in = null;
      this._auth_version = null;
      this._subscription_type = null;
      this._payment_interval = null;
      this._is_free_user = true;
      this._limit = -1;
      this._usage = -1;
      this._credits = -1;
    }
  
    get email() {
      return this._email;
    }
  
    get aiwp_logged_in() {
      return this._aiwp_logged_in;
    }
  
    get auth_version() {
      return this._auth_version;
    }
  
    get subscription_type() {
      return this._subscription_type;
    }
  
    get subscription_type() {
      return this._subscription_type;
    }
  
    get payment_interval() {
      return this._payment_interval;
    }
  
    get credits() {
      return this._credits;
    }
  
    get usage() {
      return this._usage;
    }
  
    get limit() {
      return this._limit;
    }
  
    get is_free_user() {
      return this._is_free_user;
    }
  
    set email(value) {
      this._email = value;
    }
  
    set aiwp_logged_in(value) {
      this._aiwp_logged_in = value;
    }
  
    set auth_version(value) {
      this._auth_version = value;
    }
  
    set subscription_type(value) {
      this._subscription_type = value;
    }
  
    set subscription_type(value) {
      this._subscription_type = value;
    }
  
    set payment_interval(value) {
      this._payment_interval = value;
    }
  
    set credits(value) {
      this._credits = value;
    }
  
    set usage(value) {
      this._usage = value;
    }
  
    set limit(value) {
      this._limit = value;
    }
  
    set is_free_user(value) {
      this._is_free_user = value;
    }
  
  }
  
  module.exports = User;